<template>
  <el-dialog title="重置密码" :visible.sync="dialogVisible" width="1100px">
    <el-form label-width="90px">
      <el-form-item style="color: #f56c6c">重置后，用户的初始密码为：123456，请告知用户及时修改~</el-form-item>
      <el-form-item label="证明材料">
        <div class="img-wrap">
          <div v-for="(item, index) in fileList" :key="index" class="img-item">
            <img :src="item" />
            <div class="img-item__action">
              <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item)"></i>
              <i class="el-icon-delete" @click="handleRemove(index)"></i>
            </div>
          </div>
          <el-upload
            v-if="fileList.length < 5"
            :action="uploadApi"
            :headers="{ token }"
            :show-file-list="false"
            accept="image/gif, image/jpeg, image/png"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item>
        请上传证明材料图片，内容包括不限于：班主任确认截图、学生本人证明，支持png/jpg格式的图片，文件大小不少于100kb，最多支持5张图片。
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </template>

    <el-dialog :visible.sync="dialogImgVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { postUserResetPassword } from '@/api/user'
import { uploadApi } from '@/api/common'
import { getToken } from '@/utils/auth'
export default {
  name: 'UserResetPassword',
  data() {
    return {
      dialogVisible: false,
      uploadApi,
      token: getToken(),
      dialogImageUrl: '',
      dialogImgVisible: false,
      fileList: [],
      uuid: '',
    }
  },
  methods: {
    show(uuid) {
      Object.assign(this.$data, this.$options.data())
      this.uuid = uuid
      this.dialogVisible = true
    },
    handleRemove(index) {
      this.fileList.splice(index, 1)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file
      this.dialogImgVisible = true
    },
    beforeUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!')
        return false
      }
      return true
    },
    handleSuccess(res) {
      if (res.code === 20000) {
        this.fileList.push(res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleConfirm() {
      if (!this.fileList.length) {
        return this.$message.error('请上传证明材料')
      }
      this.$confirm('确认重置该用户的初始密码吗？该操作不可逆，请谨慎操作！', '提示', {
        confirmButtonText: '确定重置',
      })
        .then(() => {
          postUserResetPassword({
            uuid: this.uuid,
            images: this.fileList,
          }).then(() => {
            this.$message.success('密码已重置')
            this.dialogVisible = false
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-upload {
  .el-upload-dragger {
    width: 100%;
    height: 100%;
  }
}

/deep/ .el-upload {
  width: 148px;
  height: 148px;
  border-radius: 4px;
  // border: 1px dashed #409eff;
  border: 1px dashed #c0ccda;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fbfdff;

  &:hover {
    border-color: #409eff;
  }
}

.img-wrap {
  display: flex;
  width: 148px;
  height: 148px;

  .img-item {
    position: relative;
    margin-right: 10px;
    border: 1px dashed #c0ccda;

    &:hover {
      .img-item__action {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    img {
      width: 148px;
      height: 148px;
    }

    &__action {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 20px;

      i {
        margin: 0 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
